import React, { createContext, useContext, useState } from 'react';

const BecomeGuestContext = createContext(null);

export const BecomeGuestProvider = ({ children }) => {
    const [showModal, setShowModal] = useState(false);
    const [canBecomeGuest, setCanBecomeGuest] = useState(false);
    const [isFreeAccount, setIsFreeAccount] = useState(false);
    return (
        <BecomeGuestContext.Provider value={{
            showModal, setShowModal,
            canBecomeGuest, setCanBecomeGuest,
            isFreeAccount, setIsFreeAccount,
        }}>
            {children}
        </BecomeGuestContext.Provider>
    );
};

export const useBecomeGuest = () => {
    const ctx = useContext(BecomeGuestContext);
    return ctx || {
        showModal: false, setShowModal: () => {},
        canBecomeGuest: false, setCanBecomeGuest: () => {},
        isFreeAccount: false, setIsFreeAccount: () => {},
    };
};
